import { render, staticRenderFns } from "./Template-14.vue?vue&type=template&id=67a46734&scoped=true&"
import script from "./Template-14.vue?vue&type=script&lang=js&"
export * from "./Template-14.vue?vue&type=script&lang=js&"
import style0 from "./Template-14.vue?vue&type=style&index=0&id=67a46734&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a46734",
  null
  
)

export default component.exports